module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAMBAMAAACKHmBGAAAAMFBMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmy/KNBAAAAD3RSTlMABNcG5N3r0Qiv8cm6nn8Id8XbAAAAYElEQVQI12N4ywADjCcZ/m+AcYT+M7T9hknoZzAw5xdCOKLfDBgYTL4LgCXinYEks78iiGPyxQAs/0kAJBTIAFEApNuAIhAzvwpw5CvCDXXgAkpAgfiv/4UMcDD/J5gCAGrjF4/yBz1gAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_down.png
// module id = 44
// module chunks = 1